import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import Popup from '../../Popup';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../CustomAlert';
import EditIcon from '@material-ui/icons/Edit';
import { Helmet } from 'react-helmet';
import { getPartyDocumentWithUserId } from '../../../Backend/firebase/party';
import PartyFilter from './PartyFilter';
import UpdateParty from './UpdateParty';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'PartyName', label: 'Party Name', disableSorting: false },
    { id: 'PartyType', label: 'Party Type', disableSorting: false },
    { id: 'Address', label: 'Address', disableSorting: true },
    { id: 'DrugLicense', label: 'Drug License', disableSorting: true },
    { id: 'OverDue', label: 'OverDue Amount', disableSorting: true },
    { id: 'LastPayment', label: 'Last Payment', disableSorting: true },
    { id: 'GSTNo', label: 'GST No', disableSorting: false },
    { id: 'action', label: 'Action', disableSorting: false },
]

function AllParty() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openPopup, setOpenPopup] = useState(false);
    const [updatedPartyId, setUpdatedPartyId] = useState('');
    const [uniquePartyId, setUniquePartyId] = useState('');
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.PartyName.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getParty = await getPartyDocumentWithUserId(userData.uid);
                setRecords(getParty);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Party", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const updateParty = (_id, partyId) => {
        setUniquePartyId(_id);
        setUpdatedPartyId(partyId);
        setOpenPopup(true);
    };

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getParty = await getPartyDocumentWithUserId(userData.uid);
                console.log("getParty",getParty)
                setRecords(getParty);
                setIsLoading(false);
                setNotificationMessage('Party data has updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get Party", error)
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allParty">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Party you have posted till now." />
                            <title>Party | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <PartyFilter handleFilters={handleFilters} refreshData={refreshData} />
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Party..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                {/* <TblContainer>
                                    <TblHead />
                                    <TableBody> */}
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 topSkills topSkills__productDisplay" key={item.id}>
                                                        <div className="card-events card-products all-products">
                                                            <div className="card-events-body d-flex flex-column background__color position__class">
                                                                <div className="product__edit">
                                                                    <Tooltip title="Edit Party" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => updateParty(item._id, item.uniqueId)}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                                <div className="party-events-details">
                                                                    <h5 className="card-events-title white__color product__mainTitle">{item.PartyName}</h5>
                                                                    <p className="card-events-title white__color">{item.PartyType ? item.PartyType : "NA"}</p>
                                                                    <p className="card-events-title white__color">GST No: <b>{item.GSTNo ? item.GSTNo : 'NA'}</b></p>
                                                                    {item.DrugLicense && <p className="card-events-title white__color">Drug License: <b>{item.DrugLicense}</b></p>}
                                                                    {item.OverDue && <p className="card-events-title white__color">Over Due: <b>{item.OverDue ? `Rs. ${item.OverDue}` : 'Rs. 0'}</b></p>}
                                                                    {item.LastPayment && <p className="card-events-title white__color">Last Payment: <b>{item.LastPayment ? `Rs. ${item.LastPayment}` : 'Rs. 0'}</b></p>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <TableRow key={item.id}>
                                                        <TableCell>{item.PartyName}</TableCell>
                                                        <TableCell>{item.PartyType}</TableCell>
                                                        <TableCell>{item.Address ? item.Address : "NA"}</TableCell>
                                                        <TableCell>{item.DrugLicense ? item.DrugLicense : "NA"}</TableCell>
                                                        <TableCell>
                                                            <span style={{
                                                                backgroundColor: 'red', color: 'white', padding: '5px 2px',
                                                                borderRadius: '2px', fontWeight: '500'
                                                            }}>{item.OverDue ? `Rs. ${item.OverDue}` : 'Rs. 0'}</span>
                                                        </TableCell>
                                                        <TableCell>
                                                            <span style={{
                                                                backgroundColor: 'green', color: 'white', padding: '5px 2px',
                                                                borderRadius: '2px', fontWeight: '500'
                                                            }}>{item.LastPayment ? `Rs. ${item.LastPayment}` : 'Rs. 0'}</span>
                                                        </TableCell>
                                                        <TableCell>{item.GSTNo ? item.GSTNo : "NA"}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Edit Party" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => updateParty(item._id, item.uniqueId)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow> */}
                                                </>
                                            ))
                                        }
                                    {/* </TableBody>
                                </TblContainer> */}
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Party Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Party" popupSize="md">
                <UpdateParty _id={uniquePartyId} partyId={updatedPartyId} setOpenPopup={setOpenPopup} refreshData={refreshData} />
            </Popup>
        </>
    )
}

export default AllParty
